import { render, staticRenderFns } from "./ValuePassUnits.vue?vue&type=template&id=7621bd8a&"
import script from "./ValuePassUnits.vue?vue&type=script&lang=js&"
export * from "./ValuePassUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports